export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyAzzlTFyZikYaiAaeOgP-3Uh4ngPQovtlA',
    authDomain: 'servlymaindev.firebaseapp.com',
    databaseURL: 'https://servlymaindev.firebaseio.com',
    projectId: 'servlymaindev',
    storageBucket: 'servlymaindev.appspot.com',
    messagingSenderId: '116569791735',
    appId: '1:116569791735:web:2541366c18ba976e46c7f2',
    measurementId: 'G-MCQTE0FPQE',
  },
  api: 'https://mbdev.myservy.com',
  appurl: 'https://sm-sit.myservy.com',
  urlservicecenter: 'https://sc-sit.myservy.com',
  planFree: 'e7d57864-f33c-4f00-a255-59a4d24294aa',
  planMyservy: '31bab5b5-5754-4cbb-b37c-3c498344b20e',
  planBasic: 'b28634ca-90c5-40b2-80b7-c0f56e4e3339',
  planEsential: 'e9ef8359-33a9-4016-8e2b-f1ddb2fdfe46',
  planAdvanced: 'fd1a951c-dcd2-44e2-863b-c16a3f7a8f81',
  planMyservyAnnual: '1cc01c09-10fe-486b-b6a0-239825294d00',
  planBasicAnnual: '2ab72b49-ea11-4c01-b19b-3d4495002717',
  planEsentialAnnual: '6a1493ea-ba71-405a-81f4-179723dad69d',
  planAdvancedAnnual: 'e5bb3a55-2985-4456-866d-b9723163b17b',
  stripePublishableKeyMyservy: 'pk_test_O9RMxYy4QUUB8GDCNeNAzomd',
  urlFuntionEmailConfirm:
    'https://us-central1-servlymaindev.cloudfunctions.net/app/EmailConfirm/',
  urlFuntionDeleteUser:
    'https://us-central1-servlymaindev.cloudfunctions.net/app/DeleteUser/',
  bridgeUrl: 'https://sharedev.myservy.com/share',
  useFunctionsEmulator: false,
  restricion: false,

  recharges: [
    {
      servicecenterId: '0f63d5f6-bd12-493c-9d48-f8ac283e603a',
      plan30: {
        name: '30 días',
        description: 'Servicio Fibra Cool 50 MPS x 30 Días x 25 $',
        amountoftime: 30,
        amount: 25,
      },
      plan10: {
        name: '10 días',
        description: 'Servicio Fibra Cool 50 MPS x 10 Días x  10$',
        amountoftime: 10,
        amount: 10,
      },
    },
  ],
};
